import { createReducer, on } from "@ngrx/store";
import { initialSettingsState } from "./settings.state";
import { SettingsActions } from "./settings.actions";

export const settingsReducer = createReducer(
    initialSettingsState,
    on(SettingsActions.experimentalMode, (state, { enable }) => {
        return { ...state, experimentalMode: enable };
    }),
);